import { GameLiveConnectionMethod } from '../../../services/liveConnection';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { wheelGameService } from '../wheelService/gameService';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

export class WheelGameConnection {
  changeWheelType(params) {
    return mainGameConnection.invoke(GameLiveConnectionMethod.ChangeGameType, params);
  }

  executeGameConnections() {
    mainGameConnection.onDoSpinResult(wheelGameService.handleDoSpinResult.bind(wheelGameService));
    mainGameConnection.onGetInitialStateResult(
      wheelGameService.onGetInitialStateResult.bind(wheelGameService)
    );
    mainGameConnection.on(
      GameLiveConnectionMethod.ChangeGameTypeResult,
      wheelGameService.handleChangeWheelTypeResult.bind(wheelGameService)
    );
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const wheelGameConnection = new WheelGameConnection({ url: `${socketUrl}game` });
